import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import SpecificationsList from './SpecificationsList';
import ESRSpecificationsList from './ESRSpecificationsList';
import CreateSpecification from './CreateSpecification';
import CreateESRSpecification from './CreateESRSpecification';
import ViewSpecification from './ViewSpecification';
import EditSpecification from './EditSpecification';

function Specifications() {
  const location = useLocation();
  const isESR = location.pathname.includes('esr');

  return (
    <Routes>
      <Route index element={<SpecificationsList type="regular" />} />
      <Route path="esr" element={<ESRSpecificationsList />} />
      <Route path="orders" element={<SpecificationsList type="emergency" />} />
      <Route path="emergency" element={<SpecificationsList type="emergency" />} />
      <Route path="create" element={<CreateSpecification />} />
      <Route path="create-esr" element={<CreateESRSpecification />} />
      <Route path=":specificationId" element={<ViewSpecification />} />
      <Route path=":specificationId/edit" element={<EditSpecification />} />
    </Routes>
  );
}

export default Specifications;
